import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SharedModule } from '../../../_shared/shared.module';
import { TaskModule } from '../../task/task.module';
import { ActionRequiredComponentRoutingModule } from './action-routing.module';
import { ActionRequiredComponent } from './action.component';

@NgModule({
  declarations: [
    ActionRequiredComponent,
  ],
  imports:      [
    SharedModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide:    DateAdapter,
      useFactory: adapterFactory,
    }),
    TaskModule,
    ActionRequiredComponentRoutingModule,
  ],
})
export class ActionRequiredModule {
}